import axios from 'config/axiosConfig'
import { statuses } from 'keys';
import { getAssessmentFilters, getScoreRatingFilters } from 'utils/filtering';
import api, { go, reading_assessment, assessments, score_rating_methods } from 'keys/apis';

export const getRatingFetch = ({ id }) => {
    if (id)
        return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/get_rating/`)
}

export const getFluencyStatsByAssessmentFetch = ({ id, params }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/get_fluency_stats_by_assessment/`, {
        params: params
    })
}

export const getFluencyReadingStatsByAssessmentFetch = ({ id, params }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/get_fluency_reading_stats_by_assessment/`, {
        params: params
    })
}

export const getCorrectWordsPerMinuteStatsByAssessmentFetch = ({ id, params }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/get_correct_words_per_minute_stats_by_assessment/`, {
        params: params
    })
}


export const getWpmDistributionFetch = ({ id, params }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_wpm_distribution/`, {
        params: params
    })
}

export const saveScoreRatingMethodsFetch = (data) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}${score_rating_methods}save_score_rating_methods/`, {
        score_rating: data
    })
}

export const getAccuracyDistributionFetch = ({ id, params }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_percent_accuracy_distribution/`, {
        params: params
    })
}

export const getFactoredAccuracyDistributionFetch = ({ id, params }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_factored_percent_accuracy_distribution/`, {
        params: params
    })
}

export const getFluencyReadingDistributionFetch = ({ id, params }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_fluency_reading_distribution/`, {
        params: params
    })
}

export const getCorrectWordsPerMinuteDistributionFetch = ({ id, params }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_correct_words_per_minute_distribution/`, {
        params: params
    })
}

export const getFluencyStatsFetch = ({ headerFilters, assessmentFilters, statusFilters, testTaker }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_fluency_stats/`, {
        params: params
    })
}

export const getCorrectWordsPerMinuteStatsFetch = ({ headerFilters, assessmentFilters, statusFilters, testTaker }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_correct_words_per_minute_stats/`, {
        params: params
    })
}

export const getReadingFluencyStatsFetch = ({ headerFilters, assessmentFilters, statusFilters, testTaker }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_fluency_reading_stats/`, {
        params: params
    })
}

export const getSelfCorrectionStatsFetch = ({ headerFilters, assessmentFilters, statusFilters, testTaker }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_self_correction_stats/`, {
        params: params
    })
}

export const getMinorErrorStatsFetch = ({ headerFilters, assessmentFilters, statusFilters, testTaker }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_minor_error_stats/`, {
        params: params
    })
}

export const getHesitationsStatsFetch = ({ headerFilters, assessmentFilters, statusFilters, testTaker }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_hesitations_stats/`, {
        params: params
    })
}

export const getAccuracyStatsByAssessmentFetch = ({ id, params }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/get_accuracy_stats_by_assessment/`, {
        params: params
    })
}

export const getAccuracyStatsFetch = ({ headerFilters, assessmentFilters, statusFilters, testTaker }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_accuracy_stats/`, {
        params: params
    })
}

export const getFactoredAccuracyStatsFetch = ({ headerFilters, assessmentFilters, statusFilters, testTaker }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_factored_accuracy_stats/`, {
        params: params
    })
}

export const getFactoredAccuracyStatsByAssessmentFetch = ({ id, params }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/get_factored_accuracy_stats_by_assessment/`, {
        params: params
    })
}

export const getMatchingLearningFetch = ({ rating, assessmentFilters }) => {
    const { percent_accuracy_rating_index, words_per_minute_rating_index, words_per_minute_rating_id, percent_accuracy_rating_id } = rating
    const maxIndicationRatingId = percent_accuracy_rating_index > words_per_minute_rating_index ? percent_accuracy_rating_id : words_per_minute_rating_id

    let params = getAssessmentFilters(null, assessmentFilters)
    params.rating = maxIndicationRatingId

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}definitions/${api.get_matching_learning}/`, {
        params: params,
    })
}

export const getScoreRatingMethodFetch = ({ dispatch, id }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/get_score_rating_method/`)
}


export const getRatingsFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}ratings/`)
}

export const getScoreRatingSemestersFetch = ({ signal, assessmentFilters }) => {
    let params = getScoreRatingFilters({ assessmentFilters })
    // params.method = 2

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}${score_rating_methods}get_score_rating_semesters/`, {
        signal,
        params: params
    })
}






